import { ISection } from "data/Data";

/** What the inviter chose to hand over on the add-team-member page. */
export enum SharingPreference {
  all = "all",
  some = "some",
  none = "none",
}

/**
 * The sections an invite hands over, for both the emailed invite and the share link.
 * `sections` is sliced past General Info, which nobody is added to.
 */
export function sectionsForPreference(
  preference: SharingPreference,
  sections: ISection[],
  ticked: number[],
): number[] {
  switch (preference) {
    case SharingPreference.all:
      return sections.slice(1).map((section) => section.id);
    case SharingPreference.some:
      return ticked;
    case SharingPreference.none:
      return [];
  }
}
